import { render, staticRenderFns } from "./IpsEditor.vue?vue&type=template&id=48f91dfc"
import script from "./IpsEditor.vue?vue&type=script&lang=js"
export * from "./IpsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports